import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import DocumentTypeForm from '../../../components/forms/DocumentTypeForm';
import { useDocumentTypeApi } from '../../../hooks/useDocumentTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { DocumentTypeDTO } from '../../../services/apiClient';

const DocumentTypeCreate: React.FC = () => {
  const { create, isLoading } = useDocumentTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Document Types', href: '/admin/documenttypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: DocumentTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/documenttypes');
    } catch (error) {
      console.error('Error creating DocumentType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/documenttypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.DocumentType.Edit'
    >
        <DocumentTypeForm
          initialValues={{} as DocumentTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/documenttypes')}
        />
    </AdminLayout>
  );
};

export default DocumentTypeCreate;